<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-show="showUI">
      <div class="input_container" v-if="isFieldNeeded('email')">
        <weex-text class="input_label">{{getFieldLabel('email')}}</weex-text>
        <weex-text class="input_label margin-top-5 font-size-sm" >
          {{emailInstruction}}
        </weex-text>
        <input
          class="input_with_border_bottom"
          type="email"
          :value="getFieldValue('email')"
          @input="onInputEntered('email', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('email')"
          :error-msg="getErrorMsg('email')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('mothers_maiden_name')">
        <weex-text class="input_label">{{getFieldLabel('mothers_maiden_name')}}</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('mothers_maiden_name')"
          @input="onNameEntered('mothers_maiden_name', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('mothers_maiden_name')"
          :error-msg="getErrorMsg('mothers_maiden_name')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('father_name')">
        <weex-text class="input_label">{{getFieldLabel('father_name')}}</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('father_name')"
          @input="onNameEntered('father_name', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('father_name')"
          :error-msg="getErrorMsg('father_name')"
        ></field-error-item>
      </div>

      <div class="dropdown_container" v-show="isFieldNeeded('marital_status')">
        <wxc-dropdown
          default-item="Select"
          :title="getFieldLabel('marital_status')"
          :select-item="getFieldValue('marital_status')"
          :config="dropdownConfig"
          :list="maritalStatusOptions"
          @onItemSelected="onInputEntered('marital_status', $event.value)"
        ></wxc-dropdown>
        <field-error-item
          :show-error="showFieldError('marital_status')"
          :error-msg="getErrorMsg('marital_status')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('number_of_dependents')">
        <weex-text class="input_label">{{getFieldLabel('number_of_dependents')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          maxlength="2"
          :value="getFieldValue('number_of_dependents')"
          @input="onInputEntered('number_of_dependents', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('number_of_dependents')"
          :error-msg="getErrorMsg('number_of_dependents')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('alternate_phone_number')">
        <weex-text class="input_label">{{getFieldLabel('alternate_phone_number')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          maxlength="12"
          :value="getFieldValue('alternate_phone_number')"
          @input="onInputEntered('alternate_phone_number', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('alternate_phone_number')"
          :error-msg="getErrorMsg('alternate_phone_number')"
        ></field-error-item>
      </div>

      <div class="dropdown_container" v-show="isFieldNeeded('address_ownership_type')">
        <wxc-dropdown
          default-item="Select"
          :title="getFieldLabel('address_ownership_type')"
          :select-item="getFieldValue('address_ownership_type')"
          :config="dropdownConfig"
          :list="addressOwnerTypes"
          @onItemSelected="onInputEntered('address_ownership_type', $event.value)"
        ></wxc-dropdown>
        <field-error-item
          :show-error="showFieldError('address_ownership_type')"
          :error-msg="getErrorMsg('address_ownership_type')"
        ></field-error-item>
      </div>

      <div class="input_container" v-if="isFieldNeeded('current_address_years')">
        <weex-text class="input_label">{{getFieldLabel('current_address_years')}}</weex-text>
        <input
          class="input_with_border_bottom"
          type="number"
          maxlength="2"
          :value="getFieldValue('current_address_years')"
          @input="onInputEntered('current_address_years', $event.target.value)"
          return-key-type="next">
        <field-error-item
          :show-error="showFieldError('current_address_years')"
          :error-msg="getErrorMsg('current_address_years')"
        ></field-error-item>
      </div>

      <wxc-button
        text="Next"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>

import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import FieldErrorItem from "../../layout/FieldErrorItem";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import StageCommentItem from "../../layout/StageCommentItem";
import WxcDropdown from "../../../../weex-ui/packages/wxc-dropdown/index";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import AlertService from "../../core/alert/AlertService";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import DataSource from "../../../data/DataSource";
import EzUtils from "../../../utils/EzUtils";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import { DataTables } from "../../../utils/DataTables";
import DataTableUtils from "../../../utils/DataTableUtils";
import { Activities } from "../../../utils/ActivityNavigator";
import { DefaultResourceConfig } from "../../../utils/ImageResourcesUtil";
import RefreshItem from "../../layout/RefreshItem";
import DynamicFieldUtils, { FieldTypes } from "../../../utils/DynamicFieldUtils";
import { ValidationPatterns } from "../../../utils/ValidationPatterns";
import PersonalDetails from "../../../data/model/PersonalDetails";
import storageUtil from "../../../utils/StorageUtil";

const ALL_FIELDS_DATA = {
  email: {
    key: "email",
    label: "Email Address",
    validation: ValidationPatterns.EMAIL_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Email.",
    optional: false
  },

  mothers_maiden_name: {
    key: "mothers_maiden_name",
    label: "Mother's Name",
    validation: ValidationPatterns.CHAR_ONLY_MIN_THREE,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Name.",
    optional: false
  },

  father_name: {
    key: "father_name",
    label: "Father's Name",
    validation: ValidationPatterns.CHAR_ONLY_MIN_THREE,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Name.",
    optional: false
  },

  marital_status: {
    key: "marital_status",
    label: "Marital Status",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select Marital Status.",
    optional: false
  },

  number_of_dependents: {
    key: "number_of_dependents",
    label: "No of Dependents",
    validation: ValidationPatterns.NUMBER_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Number of Dependents.",
    optional: false
  },

  alternate_phone_number: {
    key: "alternate_phone_number",
    label: "Alternate Phone No",
    validation: ValidationPatterns.PHONE_NUMBER_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid Phone Number.",
    optional: false
  },

  address_ownership_type: {
    key: "address_ownership_type",
    label: "Address Ownership Type",
    validation: "",
    fieldType: FieldTypes.DROPDOWN,
    errorMsg: "Please select Address Ownership Type.",
    optional: false
  },

  current_address_years: {
    key: "current_address_years",
    label: "Years At Current Address",
    validation: ValidationPatterns.YEARS_PATTERN,
    fieldType: FieldTypes.EDIT_FIELD,
    errorMsg: "Please enter valid no of Years.",
    optional: false
  }
};

export default {
  name: "PersonalDetailsActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    ToolBar,
    WxcButton,
    Loading,
    WxcDropdown,
    StageCommentItem,
    RefreshItem,
    FieldErrorItem
  },
  data: () => ({
    toolbarTitle: "Personal Details",
    personalDetails: {
      email: null,
      mothers_maiden_name: null,
      father_name: null,
      marital_status: null,
      number_of_dependents: null,
      alternate_phone_number: null,
      address_ownership_type: null,
      current_address_years: null
    },
    addressOwnerTypes: [],
    maritalStatusOptions: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showUI: false,
    dynamicFields: null,
    invalidFields: [],
    showRefreshItem: false
  }),

  methods: {
    isFieldNeeded(key) {
      return this.dynamicFields == null || this.dynamicFields[key] != null;
    },

    getFieldLabel(key) {
      return this.dynamicFields && this.dynamicFields[key] && this.dynamicFields[key]["label"]
        ? this.dynamicFields[key]["label"]
        : ALL_FIELDS_DATA[key]["label"];
    },

    getFieldValue(key) {
      return this.personalDetails ? this.personalDetails[key] : "";
    },

    showFieldError(fieldKey) {
      return this.invalidFields && this.invalidFields.includes(fieldKey);
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    onNameEntered(key, value) {
      this.onInputEntered(key, EzUtils.convertToUpperCamelCase(value));
    },

    onInputEntered(key, value) {
      this.personalDetails[key] = value;
      this.removeFromInvalidFieldsIfValid(key);
    },

    removeFromInvalidFieldsIfValid(key) {
      this.invalidFields = DynamicFieldUtils.removeFromInvalidFieldsIfValidValue(
        this.invalidFields,
        key,
        this.personalDetails[key],
        ALL_FIELDS_DATA,
        this.dynamicFields
      );
    },

    onSubmit() {
      if (this.checkForValidation()) {
        this.loading = true;
        DataSource.getDataTableInfo(DataTables.PERSONAL_DETAILS, LoanScopeDataHolder.getClientId())
          .then(personalDetailsRes => {
            if (personalDetailsRes.errorOccurred) {
              this.showError(personalDetailsRes.data)
            } else {
              const personalDetails = PersonalDetails.getPersonalDetails(this.personalDetails);
              if (EzUtils.isNotEmpty(personalDetailsRes.data)) {
                DataSource.updateDataTableEntry(
                  DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  personalDetails
                )
                  .then(res => {
                    if (res.errorOccurred) {
                      this.showError(res.data);
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              } else {
                DataSource.addDataTableEntry(
                  DataTables.PERSONAL_DETAILS,
                  LoanScopeDataHolder.getClientId(),
                  personalDetails
                )
                  .then(res => {
                    if (res.errorOccurred) {
                      this.showError(res.data);
                    } else {
                      this.completeCurrentTaskAndGetNextTask();
                    }
                  })
              }
            }
          })
      }
    },

    checkForValidation() {
      this.invalidFields = DynamicFieldUtils.validateDynamicFieldsForRequiredFields(
        this.personalDetails,
        ALL_FIELDS_DATA,
        this.dynamicFields
      );

      return !this.invalidFields || this.invalidFields.length === 0;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data)
          }
        });
    },

    showToast(string) {
      AlertService.showToast(string);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getDataTableByDataTableName(DataTables.PERSONAL_DETAILS)
        .then(dataTableRes => {
          if (dataTableRes.errorOccurred) {
            this.showError(dataTableRes.data);
            this.showRefreshItem = true;
          } else {
            const maritalStatusList = DataTableUtils.getOptionsList(
              dataTableRes.data,
              ALL_FIELDS_DATA.marital_status.key
            );
            this.maritalStatusOptions = [];
            maritalStatusList && maritalStatusList.forEach(maritalStatus => {
              if (maritalStatus) {
                this.maritalStatusOptions.push({ title: maritalStatus, value: maritalStatus });
              }
            });

            const addressOwnerTypeList = DataTableUtils.getOptionsList(
              dataTableRes.data,
              ALL_FIELDS_DATA.address_ownership_type.key
            );
            this.addressOwnerTypes = [];
            addressOwnerTypeList && addressOwnerTypeList.forEach(addressOwnerType => {
              if (addressOwnerType) {
                this.addressOwnerTypes.push({ title: addressOwnerType, value: addressOwnerType });
              }
            });

            DataSource.getDataTableInfo(
              DataTables.PERSONAL_DETAILS,
              LoanScopeDataHolder.getClientId()
            )
              .then(personalDetailsRes => {
                if (personalDetailsRes.errorOccurred) {
                  this.showError(personalDetailsRes.data);
                  this.showRefreshItem = true;
                } else {
                  const personalDetailsList = personalDetailsRes.data;
                  if (EzUtils.isNotEmpty(personalDetailsList)) {
                    const personalDetailsData = personalDetailsList[0];
                    this.onNameEntered(
                      ALL_FIELDS_DATA.mothers_maiden_name.key,
                      personalDetailsData[ALL_FIELDS_DATA.mothers_maiden_name.key]
                    );
                    this.onNameEntered(
                      ALL_FIELDS_DATA.father_name.key,
                      personalDetailsData[ALL_FIELDS_DATA.father_name.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.email.key,
                      personalDetailsData[ALL_FIELDS_DATA.email.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.marital_status.key,
                      personalDetailsData[ALL_FIELDS_DATA.marital_status.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.number_of_dependents.key,
                      personalDetailsData[ALL_FIELDS_DATA.number_of_dependents.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.alternate_phone_number.key,
                      personalDetailsData[ALL_FIELDS_DATA.alternate_phone_number.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.address_ownership_type.key,
                      personalDetailsData[ALL_FIELDS_DATA.address_ownership_type.key]
                    );
                    this.onInputEntered(
                      ALL_FIELDS_DATA.current_address_years.key,
                      personalDetailsData[ALL_FIELDS_DATA.current_address_years.key]
                    );
                  }

                  if (!EzUtils.isValidId(LoanScopeDataHolder.getLeadId())) {
                    this.loading = false;
                    this.showUI = true;
                    return;
                  }
                  //TODO remove this after personal details is set in backend from lead.
                  DataSource.getLeadDetails(LoanScopeDataHolder.getLeadId())
                    .then(leadDetailsRes => {
                      this.loading = false;
                      if (leadDetailsRes.errorOccurred) {
                        this.showError(leadDetailsRes.data);
                        this.showRefreshItem = true;
                      } else {
                        const leadDetails = leadDetailsRes.data;
                        const leadDetailsData = leadDetails && leadDetails.data
                          ? EzUtils.convertToJSONObjectIfString(leadDetails.data)
                          : {};
                        if (leadDetailsData && leadDetailsData.emailAddress) {
                          this.onInputEntered(
                            ALL_FIELDS_DATA.email.key,
                            leadDetailsData.emailAddress
                          );
                        }
                        this.showUI = true;
                      }
                    })
                }
              });
          }
        });
    }
  },

  created: function () {
    this.dynamicFields = DynamicFieldUtils.getRequiredDynamicFieldsData();
  },

  mounted() {
    this.fetchInitialData();
  },

  computed: {
    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.FAMILY];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    emailInstruction(){
      return LoanScopeDataHolder.isOnboardingLoan() ? " EzCred will send Delivery Advice/Disbursal Order to this email." : " ";
    }
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>